import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ContactButton.css';

interface ContactButtonProps {
  className?: string;
  onClick?: () => void;
  to?: string;
  children?: React.ReactNode;
  variant?: 'border' | 'fill';
}

const ContactButton: React.FC<ContactButtonProps> = ({ 
  className = '', 
  onClick, 
  to = '/contact', 
  children = 'CONTACT US', 
  variant = 'border' 
}) => {
  return (
    <Link 
      to={to} 
      className={`contact-button ${variant === 'fill' ? 'contact-button-fill' : 'contact-button-border'} ${className}`}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export default ContactButton; 